import Seo from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { SOCIAL } from "../data/content";

export default function Accessibility() {
  return (
    <main className="pt-16" data-testid="accessibility-page">
      <Seo title="Accessibility" description="Accessibility commitments for the Laugh at L.A. website." />
      <section className="mx-auto max-w-3xl px-4 sm:px-6 py-20">
        <Reveal>
          <h1 className="font-display text-5xl text-white">Accessibility</h1>
          <div className="mt-8 space-y-6 text-gray-300 leading-relaxed text-sm sm:text-base">
            <p>Laugh at L.A. is for everyone, and this site is built to be usable by everyone too.</p>
            <p><strong className="text-white">What we do.</strong> Every interactive element works with a keyboard. Cast cards flip on tap, click, Enter, or Space. Audio never plays until you press play. Motion is subtle, and the site honors your device's reduced-motion setting by replacing marquee and flip animations with instant transitions.</p>
            <p><strong className="text-white">Video.</strong> The trailer and protected episode play in standard players with native controls, and captions are included wherever they are supplied with the video.</p>
            <p><strong className="text-white">Feedback.</strong> If anything on this site is hard to use, tell us at <a className="text-[#F59E0B] link-gold" href={`mailto:${SOCIAL.emailShow}`}>{SOCIAL.emailShow}</a> and we'll fix it.</p>
          </div>
        </Reveal>
      </section>
    </main>
  );
}
